import Header from 'components/Header/Header';
import MetricsLayout from 'components/MetricsLayout/MetricsLayout';
import { FormattedMessage } from 'react-intl';

export default function MetricsPage() {
  return (
    <>
      <Header>
        <FormattedMessage id="sidebarMenu.metrics" />
      </Header>
      <MetricsLayout />
    </>
  );
}
